// The flow is passwordless (phone/OTP), but hello-server's signup endpoint
// still requires a password field. The user never sees or uses this value —
// authentication is via the authToken signup returns. Generated per submission
// rather than a shared constant so no two accounts share a credential.
export const generateDummyPassword = (): string =>
  `Aa1!${Math.random().toString(36).slice(2, 10)}${Math.random().toString(36).slice(2, 10)}`;

// The Medicare screen does not collect a zip (`medicareCoverage.zipCode` has no
// writer anywhere in the app) and /shipping runs *after* account creation, so
// webreg has no real address at signup time. hello-server requires zipcode and
// rejects '' with ErrorCode(1000, Bad request), so we send the state/zip pair Guy
// confirmed passes its zip↔state validation (2026-08-11) — unconditionally,
// because a real zip with an empty state is the one shape a zip↔state validator
// would be expected to reject and nothing collects a state here.
//
// If a zip is ever added back to the Medicare screen, it must ship with a state
// that matches it (`validateStateWithZipCode` / `stateToZipCodeRanges` in
// utils/state.ts); do not pass a zip through here on its own. Note ShippingStep
// sends full state names ('Alaska') to adminapi/shippings/details while signup
// takes the two-letter form, so the two are not interchangeable.
//
// OPEN (PR #101 review): whether adminapi/1.0/shippings/details reconciles the
// user's personalDetails. If it does not, this placeholder persists on the
// profile — needs a hello-server owner's answer, tracked outside this PR.
export const SIGNUP_PLACEHOLDER_STATE = 'AK';
export const SIGNUP_PLACEHOLDER_ZIP = '99999';
